import { useRef, useState } from "react";
import { ReactComponent as CalendarIcon } from "../../../../assets/General/Calendar.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/General/close.svg";
import DateRabgePicker from "../../../../components/DateRangePicker/DateRangePicker";
import useClickOutside from "../../../../hooks/useClickOutside";
import { formatDateAndTime } from "../../../../utils/dateActions";
import s from "./DateRangeFilter.module.css";

export interface DateRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

type DateRangeFilterProps = {
  date: { from?: Date; to?: Date } | undefined;
  setDate: (value: DateRange | undefined) => void;
  label: string;
};

const DateRangeFilter = ({ date, setDate, label }: DateRangeFilterProps) => {
  const datePickerMenuRef = useRef<HTMLDivElement | null>(null);
  const [showDatePicker, setShowDatePicker] = useState(false);

  useClickOutside(datePickerMenuRef, () => setShowDatePicker(false));

  return (
    <div className={s.dateRangeFilterBlock} ref={datePickerMenuRef}>
      <div
        className={s.selectDateRangeBlock}
        onClick={() => {
          setShowDatePicker((prev) => !prev);
        }}
        style={{
          backgroundColor: "rgb(46, 46, 46)",
        }}
      >
        <CalendarIcon width={25} height={25} />
        {date
          ? formatDateAndTime(date.from!, "en").formattedDate +
            " - " +
            formatDateAndTime(date.to!, "en").formattedDate
          : label}
        <div
          className={s.removeBtn}
          onClick={(e) => {
            e.stopPropagation();
            setDate(undefined);
          }}
        >
          <CrossIcon />
        </div>
      </div>
      {showDatePicker && (
        <div className={s.datePickerBlock}>
          <DateRabgePicker
            onDateChange={(value: DateRange) => setDate(value)}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
